import { environment } from '../../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class OnboardingRepositoryService {
    constructor(http) {
        this.http = http;
    }
    listByAccountId(accountId) {
        // tslint:disable-next-line:no-console
        return this.http.get(`${environment.apiUrl}v1/accounts/${accountId}/onboarding`);
    }
    findByAccountIdAndOrderNo(accountId, orderNo) {
        const orderNoNorm = orderNo.replace('/', '-');
        return this.http.get(`${environment.apiUrl}v1/accounts/${accountId}/orders/${orderNoNorm}`);
    }
}
OnboardingRepositoryService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function OnboardingRepositoryService_Factory() { return new OnboardingRepositoryService(i0.ɵɵinject(i1.HttpClient)); }, token: OnboardingRepositoryService, providedIn: "root" });
